import { render, staticRenderFns } from "./InterFeedback.vue?vue&type=template&id=dcaa1b9a&scoped=true"
import script from "./InterFeedback.vue?vue&type=script&lang=js"
export * from "./InterFeedback.vue?vue&type=script&lang=js"
import style0 from "./InterFeedback.vue?vue&type=style&index=0&id=dcaa1b9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcaa1b9a",
  null
  
)

export default component.exports